<div class="modal-header">
  <h5 class="modal-title" i18n>Close Property</h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <mat-form-field2 class="mat-block">
      <app-select
        [bindLabel]="bindLabel"
        [multiple]="false"
        [items]="types"
        formControlName="type"
        [required]="true"
        placeholder="Reason"
        i18n-placeholder
      >
      </app-select>
      <mat-error *ngIf="form.get('type').touched && form.get('type').hasError('required')" i18n>
        Reason is required
      </mat-error>
    </mat-form-field2>
    <mat-form-field2 class="mat-block">
      <textarea
        type="text"
        matInput
        rows="3"
        cdkTextareaAutosize
        placeholder="Description"
        i18n-placeholder
        formControlName="description"
      >
      </textarea>
      <mat-error *ngIf="form.get('description').touched && form.get('description').hasError('required')" i18n>
        Description is required
      </mat-error>
    </mat-form-field2>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="onSave(form)" type="button" class="btn btn-secondary-info">
    <i class="far fa-circle"></i> <ng-container i18n>Close</ng-container>
  </button>
</div>
